import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-shift-override-modal',
  templateUrl: './shift-override-modal.component.html',
  styleUrls: ['./shift-override-modal.component.css']
})
export class ShiftOverrideModalComponent implements OnInit, OnDestroy {
  @Input() overrideData: any;
  @Output() onCloseModal = new EventEmitter<void>();
  @Output() onSaved = new EventEmitter<any>();

  constructor() {}

  ngOnInit(): void {}

  closeModal() {
    this.onCloseModal.emit();
  }

  handleSaved(data: any) {
    this.onSaved.emit(data);
  }

  ngOnDestroy(): void {}
}

